module.exports = __webpack_public_path__ + "img/cg.69f8a29.webp";